export const it = {
  "REQUIRED_ACTION_KeepCapturing": "Continua a catturare",
  "REQUIRED_ACTION_PauseCapturing": "Mettere in pausa la cattura.",
  "REQUIRED_ACTION_Close": "Vicino",
  "REQUIRED_ACTION_Error": "Errore",
  "REQUIRED_ACTION_AGREE": "D'accordo",
  "REQUIRED_ACTION_DISAGREE": "Non sono d'accordo",
  "LIVENESS_ACTION_Smile": "Sorriso",
  "LIVENESS_ACTION_Frown": "Imbronciarsi",
  "LIVENESS_ACTION_Tilt Left": "Guarda a sinistra",
  "LIVENESS_ACTION_Tilt Right": "Guarda a destra",
  "LIVENESS_ACTION_Tilt Up": "Guarda in su",
  "LIVENESS_ACTION_Tilt Down": "Guarda in basso",
  "LIVENESS_ACTION_Look Straight": "Guarda dritto davanti a te.",
  "LIVENESS_ACTION_No Action": "Nessuna azione",
  "LIVENESS_ACTION_PROCESSING_LIVENESS": "Elaborazione della vivacità",
  "LIVENESS_RESULT_Thank you!.Failed": "Fallito",
  "LIVENESS_RESULT_Thank you!.Passed": "Passato",
  "LIVENESS_RESULT_Thank you!.ActionTimedOut": "Azione scaduta",
  "LIVENESS_RESULT_Thank you!.Interrupted": "Interrotto",
  "LIVENESS_RESULT_Thank you!.Undefined": "Non definito",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TITLE": "Guarda dritto davanti a te",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TEXT": "Tieni sempre gli occhi sullo schermo",
  "LIVENESS_ACTION_LOOK_LEFT_TITLE": "Ruota leggermente la testa verso sinistra",
  "LIVENESS_ACTION_LOOK_LEFT_TEXT": "Tieni sempre gli occhi sullo schermo",
  "LIVENESS_ACTION_LOOK_RIGHT_TITLE": "Ruota leggermente la testa verso destra",
  "LIVENESS_ACTION_LOOK_RIGHT_TEXT": "Tieni sempre gli occhi sullo schermo",
  "LIVENESS_ACTION_LOOK_UP_TITLE": "Ruota leggermente la testa verso l'alto",
  "LIVENESS_ACTION_LOOK_UP_TEXT": "Tieni sempre gli occhi sullo schermo",
  "LIVENESS_ACTION_LOOK_DOWN_TITLE": "Ruota leggermente la testa verso il basso",
  "LIVENESS_ACTION_LOOK_DOWN_TEXT": "Tieni sempre gli occhi sullo schermo",
  "LIVENESS_ACTION_SMILE_TITLE": "Sorridi",
  "LIVENESS_ACTION_SMILE_TEXT": "Tieni sempre gli occhi sullo schermo",
  "LIVENESS_ACTION_FROWN_TITLE": "Accigliati",
  "LIVENESS_ACTION_FROWN_TEXT": "Tieni sempre gli occhi sullo schermo",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE": "Uh Oh...Sei troppo vicino.",
  "PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE": "Uh Oh...Sei troppo vicino.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE": "Non siamo in grado di rilevare un viso nell'immagine. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE": "Uh Oh...Sei troppo lontano.",
  "PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE": "Uh Oh...Qualcosa è andato storto.",
  "ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES": "Non siamo in grado di rilevare un volto nell'immagine. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE": "Oh...Non siamo in grado di rilevare un volto.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE": "Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE": "Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE": "Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_None_TITLE": "Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_None": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE": "Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE": "Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR": "Qualcosa è andato storto. Riprova.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE": "Oh Oh...Qualcosa è andato storto.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META": "Qualcosa è andato storto. Riprova.",
  "INITIALIZING_TITLE": "Inizializzazione",
  "INITIALIZING_DESCRIPTION": "Controllando le capacità hardware, attendere...",
  "JOURNEY_STATE_STARTED": "Iniziato",
  "JOURNEY_STATE_INPROGRESS": "In corso",
  "JOURNEY_STATE_ENDED": "Finito",
  "INFO_JOURNEY_STATE": "Stato",
  "INFO_JOURNEY_ACTION": "Azione",
  "INFO_JOURNEY_ACTION_ATTEMPT": "Tentativo d'azione",
  "INFO_JOURNEY_ID": "ID del viaggio",
  "INFO_JOURNEY_RESULT": "Risultato",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE": "Messaggio di risultato",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE": "L'ID che ci hai fornito non è aggiornato: prova qualcos'altro",
  "INFO_JOURNEY_REFERENCE": "Riferimento",
  "FLOW_STATE_NONE": "Nessuno",
  "FLOW_STATE_IDENTITY:FRONT": "Facciata anteriore",
  "FLOW_STATE_IDENTITY:BACK": "Parte posteriore",
  "FLOW_STATE_ADDRESS": "Indirizzo",
  "FLOW_STATE_SELFIE": "Autoritratto",
  "FLOW_STATE_LIVENESS": "Vivacità",
  "FLOW_STATE_COVID": "Covid",
  "PROVIDER_TITLE_CAMERA": "Fotocamera",
  "PROVIDER_TITLE_CROPPER": "Tagliatore",
  "PROVIDER_TITLE_FILESYSTEM_ID": "Carica una foto del tuo documento di identità",
  "PROVIDER_TITLE_FILESYSTEM_FACEMATCH": "Carica una tua foto",
  "PROVIDER_TITLE_FILESYSTEM_ADDRESS": "Carica una foto della tua prova di residenza",
  "PROVIDER_TITLE_FILESYSTEM_COVID": "Carica una foto del tuo documento Covid",
  "PROVIDER_TITLE_GATEWAY": "Portale",
  "PROVIDER_TITLE_LIVENESS": "Vivacità",
  "PROVIDER_TITLE_LOGIN": "Accesso",
  "PROVIDER_TITLE_RESULTS": "Risultati",
  "PROVIDER_TITLE_SCANNER": "Scansiona il tuo documento di identità",
  "PROVIDER_TITLE_VIEW_ID": "Controlla l'anteprima del tuo documento di identità",
  "PROVIDER_TITLE_VIEW_FACEMATCH": "Controlla l'anteprima del tuo selfie",
  "PROVIDER_TITLE_VIEW_ADDRESS": "Controlla l'anteprima della tua prova di indirizzo",
  "ROVIDER_TITLE_VIEW_COVID": "Controlla l'anteprima del tuo Covid",
  "PROVIDER_SUBTITLE_FILESYSTEM_ID": "Carica una foto del tuo documento di identità nitida, a fuoco, non coperta e rivolta direttamente.",
  "PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH": "Carica una tua foto nitida, a fuoco, non coperta e rivolta direttamente",
  "PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS": "Carica una foto del tuo documento nitida, a fuoco, non coperta e rivolta direttamente.",
  "PROVIDER_SUBTITLE_FILESYSTEM_COVID": "Carica una foto del tuo documento nitida, a fuoco, non coperta e rivolta direttamente.",
  "PROVIDER_SUBTITLE_SCANNER_ID": "Posiziona la pagina della foto del tuo documento di identità rivolta verso il basso sullo scanner.",
  "PROVIDER_SUBTITLE_VIEW_ID": "Controlla che l'anteprima del tuo documento sia nitida, a fuoco, non coperta e rivolta direttamente.",
  "PROVIDER_SUBTITLE_VIEW_FACEMATCH": "Controlla che l'anteprima del tuo selfie sia nitida, a fuoco, non coperta e rivolta direttamente.",
  "PROVIDER_SUBTITLE_VIEW_ADDRESS": "Controlla che l'anteprima del tuo documento sia nitida, a fuoco, non coperta e rivolta direttamente.",
  "PROVIDER_SUBTITLE_VIEW_COVID": "Controlla che l'anteprima del tuo documento sia nitida, a fuoco, non coperta e rivolta direttamente.",
  "PROVIDER_TITLE_SMART_CAPTURE": "Cattura intelligente",
  "PROVIDER_TITLE_JOURNEY_SELECT": "Viaggio Selezionato",
  "PROVIDER_TITLE_TERMS_AND_CONDITIONS": "Termini e condizioni",
  "PROVIDER_TITLE_USER_INPUT": "Compila il seguente modulo",
  "FILESYSTEM_SUPPORTED_TYPES_FIRST": "Formati accettati:",
  "FILESYSTEM_SUPPORTED_TYPES_LIST": "JPG, PNG, PDF",
  "FILESYSTEM_SUPPORTED_TYPES_PDF": "PDF",
  "FILESYSTEM_SUPPORTED_TYPES_SECOND": "(nel caso di",
  "FILESYSTEM_SUPPORTED_TYPES_THIRD": "sarà elaborata solo la prima pagina)",
  "FILESYSTEM_SUPPORTED_TYPES_START_SELFIE": "Formati accettati: JPG, PNG",
  "FILESYSTEM_MAX_FILE_SIZE": "Dimensioni file: accettiamo qualsiasi dimensione file inferiore a",
  "FILESYSTEM_MAX_FILE_SIZE_NUMBER": "7,5 MB",
  "FILESYSTEM_CHECK_FILE_TOO_BIG": "Il tuo file è troppo grande. Carica un file inferiore a 7,5 MB.",
  "FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT": "Il tuo file è nel formato errato. Carica uno dei formati accettati.",
  "FILESYSTEM_IDENTITY_DOCUMENT": "Documento di identità",
  "FILESYSTEM_FACEMATCH": "Corrispondenza facciale",
  "FILESYSTEM_ADDRESS": "Prova di residenza",
  "FILESYSTEM_COVID": "Covid",
  "FILESYSTEM_DRAG_DROP": "Trascina e rilascia",
  "FILESYSTEM_OR": "o",
  "FILESYSTEM_CHOOSE": "Scegli un file",
  "FILESYSTEM_UPLOADING": "Caricamento in corso...",
  "TRIPLESCAN_GUIDANCE_TRYAGAIN": "Riprova",
  "FAILURE_REASON_REFER": "Il tuo documento di identità non ha superato la convalida.",
  "FAILURE_REASON_EXPIRED": "Il tuo documento di identità è scaduto.",
  "FAILURE_REASON_NOT_ACCEPTED": "Il tuo documento di identità non è un tipo di documento accettato.",
  "FAILURE_REASON_NOT_SUPPORTED": "Il tuo documento di identità non può essere classificato o non è supportato.",
  "PLEASE_TRY_AGAIN_REFER": "Riprova.",
  "PLEASE_TRY_AGAIN_EXPIRED": "Riprova con un documento valido.",
  "PLEASE_TRY_AGAIN_NOT_ACCEPTED": "Riprova con un documento diverso.",
  "PLEASE_TRY_AGAIN_NOT_SUPPORTED": "Riprova.",
  "BLUR_CHECK_REASON": "Sfocatura: il documento non è chiaro;",
  "GLARE_CHECK_REASON": "Riflesso: il documento è illeggibile a causa di una fonte di luce intensa;",
  "RESOLUTION_CHECK_REASON": "Bassa risoluzione: il documento non riempie correttamente la cornice;",
  "EDGES_CHECK_REASON": "Bordi mancanti: il documento non è posizionato correttamente nella cornice;",
  "VALIDATION_FAILED": "Convalida non riuscita",
  "VALIDATION_FAILED_REASON_DOC_UNKNOWN": "- documento sconosciuto.",
  "VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED": "- documento non accettato.",
  "VALIDATION_FAILED_REASON_DOC_EXPIRED": "- documento scaduto.",
  "PREVIEW_INFO_TITLE_ID": "Esempi di foto buone e cattive",
  "PREVIEW_INFO_GOOD": "Buono",
  "PREVIEW_INFO_BAD": "Cattivo",
  "PREVIEW_INFO_GOOD_EXAMPLE_ID": "La foto è nitida, a fuoco e direttamente di fronte.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID": "La foto deve mostrare tutti e quattro gli angoli.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ID": "Il documento non deve essere coperto.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID": "La foto non deve essere sfocata.",
  "PREVIEW_INFO_TITLE_FACEMATCH": "Suggerimenti per un selfie di buona qualità",
  "PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH": "Il selfie è nitido, a fuoco e direttamente di fronte.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH": "Il selfie deve mostrare il viso intero.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH": "Il viso non deve essere coperto.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH": "Il selfie non deve essere sfocato.",
  "PREVIEW_INFO_TITLE_ADDRESS": "Suggerimenti per una foto di buona qualità",
  "PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS": "La foto è nitida, a fuoco e rivolta direttamente di fronte.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS": "La foto deve mostrare tutti e quattro gli angoli.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS": "Il documento non deve essere coperto.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS": "La foto non deve essere sfocata.",
  "PREVIEW_INFO_TITLE_COVID": "Suggerimenti per una foto di buona qualità",
  "PREVIEW_INFO_GOOD_EXAMPLE_COVID": "La foto è nitida, a fuoco e rivolta direttamente di fronte.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID": "La foto deve mostrare tutti e quattro gli angoli.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID": "Il documento non deve essere coperto.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID": "La foto non deve essere sfocata.",
  "ATTEMPTS_REMAINING": "Numero di tentativi rimanenti:",
  "CAMERA_CAPTURE": "Accendi la fotocamera",
  "CAMERA_CAPTURE_START_BUTTON": "Avvia acquisizione automatica",
  "CAMERA_CAPTURE_CAPTION": "Clicca su Avvia acquisizione automatica per iniziare",
  "CAMERA_PREVIEW_START": "Accendi la fotocamera per avviare l'acquisizione automatica",
  "CAMERA_CONDITION_BLUR": "Sfocatura rilevata",
  "CAMERA_CONDITION_CAPTURING": "Acquisizione in corso",
  "CAMERA_CONDITION_UPLOADING": "Caricamento...attendere",
  "CAMERA_CONDITION_ALIGNMENT": "Documento non inquadrato",
  "CAMERA_CONDITION_GLARE": "Rilevato riflesso",
  "VERIFYING_TITLE": "Verifica in corso...",
  "PREPARING_PREVIEW_TITLE": "Preparazione anteprima in corso...",
  "CAMERA_CONDITION_LOW_RESOLUTION": "Documento troppo lontano",
  "CAMERA_LOADING": "Apertura fotocamera...",
  "CAMERA_SMARTCAPTURE_ON": "ACQUISIZIONE AUTOMATICA - ATTIVATA",
  "CAMERA_SMARTCAPTURE_OFF": "ACQUISIZIONE AUTOMATICA - DISATTIVATA",
  "CAMERA_CAPTURE_FRONT": "Posiziona il lato con la foto del tuo documento d'identità nella cornice sotto.",
  "CAMERA_MANUAL_CAPTURE_FRONT": "Posiziona il tuo documento di identità all'interno della cornice e clicca sul pulsante in basso",
  "CAMERA_CAPTURE_BACK": "Posiziona il RETRO del tuo documento di identità all'interno della cornice",
  "CAMERA_CAPTURE_SELFIE_CAPTION": "Posiziona il tuo viso all'interno dell'ovale, guarda direttamente nella fotocamera e clicca sul pulsante in basso per scattare un selfie.",
  "AMERA_CAPTURE_ADDRESS_CAPTION": "Posiziona la tua prova di indirizzo all'interno della cornice e clicca sul pulsante in basso per scattare una foto.",
  "CAMERA_CAPTURE_COVID_CAPTION": "Posiziona il tuo documento Covid all'interno della cornice e clicca sul pulsante in basso per scattare una foto.",
  "CAMERA_PREVENT_GLARE_HINT": "Allontana il documento da fonti di luce diretta.",
  "CAMERA_PREVENT_BLUR_HINT": "Tieni fermo il documento o il dispositivo.",
  "CAMERA_PREVENT_LOW_RES_HINT": "Inserisci completamente il documento nella cornice.",
  "CROPPER_RETRY": "Riprova",
  "CROPPER_UPLOAD": "Carica",
  "CROPPER_UPLOADING": "Caricamento in corso...",
  "FILESYSTEM_SELECT": "Seleziona",
  "FILESYSTEM_DROP_IMAGE": "o elimina immagine",
  "GATEWAY_CAMERA": "Fotocamera abilitata",
  "GATEWAY_CANCEL": "Annulla percorso",
  "LIVENESS_START": "Avvia liveness",
  "PASSIVE_LIVENESS_START": "Scatta foto",
  "LOGIN_USERNAME": "Nome utente",
  "LOGIN_PASSWORD": "Password",
  "LOGIN_SUBMIT": "Inviare",
  "RESULTS_DOCUMENTS": "Documenti",
  "RESULTS_DOCUMENTS_NONE": "Nessuno trovato",
  "RESULTS_DOCUMENT_TYPE": "Tipo di documento",
  "RESULTS_DOCUMENT_RESULT": "Risultato del documento",
  "RESULTS_EXTRACTED_FIELDS_NONE": "Dettagli del risultato",
  "RESULTS_DETAILS_NONE": "Nessuno trovato",
  "RESULTS_NEW_JOURNEY": "Inizia un nuovo viaggio.",
  "RESULTS_NO_INFORMATION": "Non ci sono informazioni per questo viaggio",
  "RESULTS_LOGOUT": "Disconnettersi",
  "RESULTS_HIGH_LEVEL_Aborted": "Interrotto",
  "RESULTS_HIGH_LEVEL_TCCDISAGREE": "Termini e condizioni interrotti",
  "RESULTS_HIGH_LEVEL_Expired": "Scaduto",
  "RESULTS_HIGH_LEVEL_NotAccepted": "Non accettato",
  "RESULTS_HIGH_LEVEL_NotSupported": "Non supportato",
  "RESULTS_HIGH_LEVEL_Notsupported": "Non supportato",
  "RESULTS_HIGH_LEVEL_Passed": "Passato",
  "RESULTS_HIGH_LEVEL_Refer": "Riferire",
  "RESULTS_HIGH_LEVEL_Undefined": "Non definito",
  "RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT": "Risultato di vitalità accumulativa",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK": "Controllo del tipo del lato anteriore del documento",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK": "Controllo del retro del documento",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY": "Politica di blocco dei documenti",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY": "Scadenza del documento",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT": "Supporto Documenti",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION": "Validazione del documento",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY": "Politica di prova del documento",
  "RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION": "Convalida di Facematch",
  "RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE": "Regola per i minorenni",
  "ESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED": "Successo necessario",
  "RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK": "Verifica della compatibilità del passaporto Covid",
  "RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK": "Controlli dei dati",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED": "Fallito",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED": "Non necessario",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED": "Passato",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED": "Saltato",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED": "Indeterminato",
  "ADDITIONAL_CHECKS_DETAILS": "Controlli aggiuntivi",
  "ADDITIONAL_CHECKS_DETAILS_NONE": "Nessuno trovato",
  "ADDITIONAL_CHECKS_DETAIL_DATACHECKS": "Controlli sui dati",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK": "Controlli Lookback",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA": "N/D",
  "GBG_SCORES": "Punteggi GBG",
  "GBG_TRUST_SCORE": "Punteggio fiduciario GBG",
  "GBG_SCORE": "Punteggio GBG",
  "VIEW_RETRY": "Foto del cambiamento",
  "VIEW_CROP": "Coltura",
  "VIEW_CROPPING": "Ritaglio...",
  "VIEW_UPLOAD": "Caricare",
  "VIEW_UPLOADING": "Caricamento...",
  "SMART_CAPTURE_INITIALIZING": "Inizio",
  "SMART_CAPTURE_START": "Inizializzazione Smart Capture, attendere...",
  "SCANNER_DESC_AVAILABLE": "Lo scanner è disponibile. Metti il tuo documento nello scanner.",
  "SCANNER_DESC_PROCESSING": "L'immagine viene elaborata dal server.",
  "SCANNER_DESC_SCANNING": "L'immagine viene scansionata dal dispositivo.",
  "SCANNER_DESC_DISCONNECTED": "Lo scanner è disconnesso dalla rete.",
  "SCANNER_DESC_NOT_CONNECTED": "Lo scanner non è collegato.",
  "SCANNER_DESC_OFFLINE": "Lo scanner è offline.",
  "SCANNER_DESC_BUSY": "Lo scanner è utilizzato da un altro utente nella tua rete locale.",
  "SCANNER_DESC_WAITING": "In attesa che la connessione venga stabilita.",
  "SCANNER_DESC_LOADING": "Attendere...",
  "SCANNER_TITLE_SCANNING": "SCANSIONE",
  "SCANNER_TITLE_DISCONNECTED": "SCOLLEGATO",
  "SCANNER_TITLE_NOT_CONNECTED": "NON CONNESSO",
  "SCANNER_TITLE_OFFLINE": "Scanner offline",
  "SCANNER_TITLE_BUSY": "Scanner occupato",
  "SCANNER_TITLE_WAITING": "IN ATTESA",
  "SCANNER_ACTION_REGISTER": "Registrare",
  "SCANNER_ACTION_RELEASE": "Rilascio",
  "CANCEL_JOURNEY": "Annullamento",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE": "Carica una foto invece",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE": "Scatta invece una foto",
  "JOURNEY_SELECT_CONTINUE": "Continua",
  "HELP_MODAL_AUTOCAPTURE_TITLE": "Come scattare una foto del documento d'identità",
  "HELP_MODAL_AUTOCAPTURE_SUBTITLE": "Quando l'acquisizione automatica è attiva, la schermata di acquisizione scatterà automaticamente una foto del documento quando avrà riconosciuto che la qualità è sufficiente.",
  "HELP_MODAL_AUTOCAPTURE_TIPS": "Suggerimenti per scattare una foto di buona qualità",
  "HELP_MODAL_AUTOCAPTURE_GLARE_TITLE": "Evitare i riflessi",
  "HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE": "Allontanare il documento dalle fonti di luce diretta.",
  "HELP_MODAL_AUTOCAPTURE_FAR_TITLE": "Documento troppo lontano",
  "AUTOCAPTURE_FAR_SUBTITLE": "Inserire il documento completamente all'interno dell'inquadratura.",
  "AUTOCAPTURE_BLUR_TITLE": "Prevenire la sfocatura",
  "HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE": "Tenere fermo il documento o il dispositivo.",
  "HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE": "Ancora in difficoltà? Scattate una foto con l'Acquisizione manuale",
  "HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE": "Cattura manuale",
  "HELP_MODAL_SELFIE_TITLE": "Come scattare un selfie",
  "HELP_MODAL_SELFIE_SUBTITLE": "Guardare direttamente nella fotocamera e fare clic sul pulsante di cattura manuale.",
  "HELP_MODAL_POA_TITLE": "Come scattare una foto della vostra prova d'indirizzo",
  "HELP_MODAL_POA_SUBTITLE": "Posizionare il documento all'interno dell'inquadratura e fare clic sul pulsante di acquisizione per scattare una foto del documento.",
  "HELP_MODAL_POA_TIPS": "Consigli per scattare una foto di buona qualità",
  "HELP_MODAL_POA_GLARE_TITLE": "Evitare i riflessi",
  "HELP_MODAL_POA_GLARE_SUBTITLE": "Allontanare il documento dalle fonti di luce diretta.",
  "HELP_MODAL_POA_FAR_TITLE": "Documento troppo lontano",
  "HELP_MODAL_POA_FAR_SUBTITLE": "Inserire completamente il documento nella cornice.",
  "HELP_MODAL_POA_BLUR_TITLE": "Prevenire la sfocatura",
  "HELP_MODAL_POA_BLUR_SUBTITLE": "Tenere fermo il documento o il dispositivo.",
  "HELP_MODAL_POA_MANUAL_CAPTURE": "Ancora difficoltà? Attivate la cattura manuale",
  "HELP_MODAL_POA_TURN_MANUAL_CAPTURE": "Acquisizione manuale",
  "HELP_MODAL_COVID_TITLE": "Come scattare una foto del documento Covid",
  "HELP_MODAL_COVID_SUBTITLE": "Posizionare il documento all'interno della cornice e fare clic sul pulsante di acquisizione per scattare una foto del documento.",
  "HELP_MODAL_COVID_TIPS": "Suggerimenti per scattare una foto di buona qualità",
  "HELP_MODAL_COVID_GLARE_TITLE": "Evitare i riflessi",
  "HELP_MODAL_COVID_GLARE_SUBTITLE": "Allontanare il documento dalle fonti di luce diretta.",
  "HELP_MODAL_COVID_FAR_TITLE": "Documento troppo lontano",
  "HELP_MODAL_COVID_FAR_SUBTITLE": "Inserire completamente il documento all'interno della cornice.",
  "HELP_MODAL_COVID_BLUR_TITLE": "Prevenire la sfocatura",
  "HELP_MODAL_COVID_BLUR_SUBTITLE": "Tenere fermo il documento o il dispositivo.",
  "HELP_MODAL_COVID_MANUAL_CAPTURE": "Ancora difficoltà? Attivate la cattura manuale",
  "HELP_MODAL_COVID_TURN_MANUAL_CAPTURE": "Cattura manuale",
  "HELP_MODAL_NEED_HELP": "Avete bisogno di aiuto?",
  "EXCEPTION": "Si è verificata un'eccezione imprevista",
  "EXCEPTION_AUTHORIZATION": "Non autorizzato",
  "EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED": "Il vostro account non è autorizzato ad accedere a questa risorsa",
  "EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID": "La combinazione di nome utente e password non è valida",
  "EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED": "È necessario abilitare l'autenticazione per utilizzare questa funzionalità",
  "EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED": "Non si è autorizzati per questo processo",
  "EXCEPTION_BAD_REQUEST": "Richiesta errata con codice di stato 400",
  "EXCEPTION_BAD_REQUEST_INVALID_IMAGE": "Immagine non valida",
  "EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE": "Il viaggio è in attesa di una risposta",
  "EXCEPTION_FLOW_STATE_JOURNEY_ENDED": "Non è possibile inviare richieste. Il viaggio è terminato",
  "EXCEPTION_FLOW_STATE_MISSING": "Stato del flusso non trovato",
  "EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION": "La funzione di richiamata deve essere una funzione valida.",
  "EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING": "Il nome dell'evento deve essere un valore di stringa.",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER": "La priorità deve essere un numero.",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER": "La priorità deve essere un numero positivo.",
  "EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR": "Il contenitore dovrebbe essere un elemento o un selettore.",
  "EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID": "Il valore non è valido.",
  "EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED": "Il valore è stato danneggiato.",
  "EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING": "La configurazione dovrebbe includere un parametro backendUrl.",
  "EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING": "I parametri forniti devono contenere le coordinate.",
  "EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING": "I parametri forniti devono contenere immagini.",
  "EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING": "I parametri forniti dovrebbero contenere la password.",
  "EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING": "I parametri forniti dovrebbero contenere il nome utente.",
  "EXCEPTION_MISSING_REQUIRED_FIELD_MISSING": "Compilare tutti i campi obbligatori",
  "EXCEPTION_POSTCODE_FORMAT_ERROR": "Il formato del codice postale non è valido minLunghezza:5 / maxLunghezza:8",
  "EXCEPTION_HOUSENUMBER_FORMAT_ERROR": "Il formato Nome/Numero civico non è valido minLunghezza:1 / maxLunghezza:20",
  "EXCEPTION_STREETNAME_FORMAT_ERROR": "Il formato Nome della via non è valido minLunghezza:1 / maxLunghezza:30",
  "EXCEPTION_TOWN_FORMAT_ERROR": "Il formato Città non è valido minLunghezza:1 / maxLunghezza:20",
  "EXCEPTION_JOURNEY_DEFINITIONS_MISSING": "Non sono disponibili definizioni di viaggio per questo canale",
  "EXCEPTION_NETWORK": "Si è verificata un'eccezione di rete, controllare la connessione e riprovare.",
  "EXCEPTION_PLATFORM_BROWSER_ONLY": "Questa funzione può essere utilizzata solo nel browser",
  "EXCEPTION_PLATFORM_UNSUPPORTED": "L'ambiente non supporta questa funzione",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED": "Le autorizzazioni per la telecamera non sono state concesse, controllare le impostazioni del browser.",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE": "",
  "EXCEPTION_PLATFORM_CAMERA_NOT_READABLE": "Non è stato possibile accedere alla telecamera. Chiudere tutte le altre applicazioni e riprovare",
  "EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE": "Non sono state trovate telecamere adatte sul dispositivo",
  "EXCEPTION_SERVER": "Richiesta fallita con codice di stato 500",
  "EXCEPTION_SERVER_UNREACHABLE": "Richiesta fallita, server irraggiungibile",
  "EXCEPTION_SERVER_DATA_NOT_PERSISTED": "Si è verificato un errore durante il processo. I dati potrebbero non essere conservati",
  "EXCEPTION_SERVER_RESULT_NOT_PASSING": "Il risultato corrente non passa",
  "EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE": "Il contesto del canvas non è disponibile",
  "EXCEPTION_TEMPLATE_CONTAINER_MISSING": "Il contenitore non è presente",
  "EXCEPTION_TEMPLATE_ELEMENTS_MISSING": "Elementi richiesti mancanti",
  "EXCEPTION_TEMPLATE_MISSING": "Template non trovato",
  "EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING": "Impossibile trovare l'elemento sorgente",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE": "Impossibile ottenere i fornitori di input",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED": "Nessun fornitore di input specificato",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE": "Il fornitore di input non è disponibile",
  "SUPPORTED_DOCUMENT_Account Statement": "Rendiconto contabile",
  "SUPPORTED_DOCUMENT_Agreement (Tenancy)": "Accordo (Locazione)",
  "SUPPORTED_DOCUMENT_Bank Document": "Documento bancario",
  "SUPPORTED_DOCUMENT_Bank Letter": "Lettera bancaria",
  "SUPPORTED_DOCUMENT_Bank Statement": "estratto conto bancario",
  "SUPPORTED_DOCUMENT_Benefit Letter": "Lettera di benefici",
  "SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)": "Certificato (Nascita, Matrimonio, Unione civile)",
  "SUPPORTED_DOCUMENT_Council Document": "Documento del Consiglio",
  "SUPPORTED_DOCUMENT_Council Letter": "Lettera del Consiglio",
  "SUPPORTED_DOCUMENT_Council Tax": "Tassa comunale",
  "SUPPORTED_DOCUMENT_Driving License": "Patente di guida",
  "SUPPORTED_DOCUMENT_Driving Licence": "Patente di guida",
  "SUPPORTED_DOCUMENT_DWP Document": "Documento DWP",
  "SUPPORTED_DOCUMENT_HMRC Document": "Documento dell'HMRC",
  "SUPPORTED_DOCUMENT_Information Sheet": "Scheda informativa",
  "SUPPORTED_DOCUMENT_Insurance Document": "Documento di assicurazione",
  "SUPPORTED_DOCUMENT_Insurance Letter": "Lettera di assicurazione",
  "SUPPORTED_DOCUMENT_Invoice": "Fattura",
  "SUPPORTED_DOCUMENT_NIC Letter": "Lettera NIC",
  "SUPPORTED_DOCUMENT_NINO Letter": "Lettera NINO",
  "SUPPORTED_DOCUMENT_Official Document": "Documento ufficiale",
  "SUPPORTED_DOCUMENT_Official Letter": "Lettera ufficiale",
  "SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)": "Lettera di rimborso (relativa a tasse o sostegno sociale)",
  "SUPPORTED_DOCUMENT_Tax Letter": "Lettera fiscale",
  "SUPPORTED_DOCUMENT_Tax Statement": "Dichiarazione fiscale",
  "SUPPORTED_DOCUMENT_Tel Bill": "Conto telefonico",
  "SUPPORTED_DOCUMENT_Tel Letter": "Lettera di Tel",
  "SUPPORTED_DOCUMENT_Telecommunication Document": "Documento di telecomunicazione",
  "SUPPORTED_DOCUMENT_TV Licence": "Licenza TV",
  "SUPPORTED_DOCUMENT_University Letter": "Lettera universitaria",
  "SUPPORTED_DOCUMENT_Utility Bill": "Fattura delle utenze",
  "SUPPORTED_DOCUMENT_Utility Document": "Documento di utilità",
  "SUPPORTED_DOCUMENT_Utility Letter": "Lettera di utilità",
  "SUPPORTED_DOCUMENT_Water Bil": "Acqua Bil",
  "SUPPORTED_DOCUMENT_Water Document": "Documento sull'acqua",
  "SUPPORTED_DOCUMENT_Agents License": "Licenza degli agenti",
  "SUPPORTED_DOCUMENT_Electoral Card": "Scheda elettorale",
  "SUPPORTED_DOCUMENT_Foreigner Identification Card": "Carta di identificazione per stranieri",
  "SUPPORTED_DOCUMENT_Health Card": "Carta sanitaria",
  "SUPPORTED_DOCUMENT_Job License": "Licenza di lavoro",
  "SUPPORTED_DOCUMENT_Membership Identification Card": "Carta di identificazione dei membri",
  "SUPPORTED_DOCUMENT_Military Identification Card": "Carta di identificazione militare",
  "SUPPORTED_DOCUMENT_National Identification Card": "Carta di identità nazionale",
  "SUPPORTED_DOCUMENT_Passport": "Passaporto",
  "SUPPORTED_DOCUMENT_Travel Permit": "Permesso di viaggio",
  "SUPPORTED_DOCUMENT_Visa": "Visto",
  "SUPPORTED_DOCUMENT_Weapons Licence": "Licenza d'armi",
  "SUPPORTED_DOCUMENT_Selfie Photo": "Foto selfie",
  "SUPPORTED_DOCUMENT_Unknown": "Sconosciuto",
  "SUPPORTED_DOCUMENT_COVIDPAS": "Passo Covid",
  "EXTRACTED_FIELDS_AddressFull": "Indirizzo Completo",
  "EXTRACTED_FIELDS_AddressCity": "Indirizzo Città",
  "EXTRACTED_FIELDS_AddressPostCode": "Codice Postale dell'Indirizzo",
  "EXTRACTED_FIELDS_LastNameFirstPart": "Ultima parte del cognome",
  "EXTRACTED_FIELDS_Sex": "genere",
  "EXTRACTED_FIELDS_BirthPlace": "Luogo di nascita",
  "EXTRACTED_FIELDS_IssueNumber": "Numero di problema",
  "EXTRACTED_FIELDS_DocumentNumberCheckDigit": "Cifra di controllo del numero di documento",
  "EXTRACTED_FIELDS_BirthDate": "Data di nascita",
  "EXTRACTED_FIELDS_DocumentNumber": "Numero del documento",
  "EXTRACTED_FIELDS_FirstName": "Primo Nome",
  "EXTRACTED_FIELDS_ArbitraryDigit": "Cifra arbitraria",
  "EXTRACTED_FIELDS_FirstNameInitial": "Iniziale del nome.",
  "EXTRACTED_FIELDS_ExpiryDate": "Data di scadenza",
  "EXTRACTED_FIELDS_IssueDate": "Data di emissione",
  "EXTRACTED_FIELDS_LastName": "Cognome",
  "EXTRACTED_FIELDS_LicenseCategory": "Categoria di licenza",
  "EXTRACTED_FIELDS_DocumentCategory": "Categoria del documento",
  "EXTRACTED_FIELDS_DocumentType": "Tipo di documento",
  "EXTRACTED_FIELDS_NationalityCode": "Codice di nazionalità",
  "EXTRACTED_FIELDS_MiddleName": "Secondo Nome",
  "EXTRACTED_FIELDS_FirstIssuanceDate": "Prima data di emissione",
  "EXTRACTED_FIELDS_SecondLastName": "Secondo Cognome",
  "EXTRACTED_FIELDS_FullName": "Nome completo",
  "EXTRACTED_FIELDS_PersonalNumber": "Numero personale",
  "EXTRACTED_FIELDS_NationalityName": "Nazionalità",
  "EXTRACTED_FIELDS_BarcodeItems": "Codice a barre",
  "EXTRACTED_FIELDS_BirthPlaceCity": "Città di nascita",
  "EXTRACTED_FIELDS_BirthPlaceState": "Stato di nascita",
  "EXTRACTED_FIELDS_BirthPlaceCountry": "Paese di nascita",
  "EXTRACTED_FIELDS_MRZFull": "MRZ completo",
  "EXTRACTED_FIELDS_MRZLine1": "MRZ Linea 1",
  "EXTRACTED_FIELDS_MRZLine2": "MRZ Linea 2",
  "EXTRACTED_FIELDS_MRZLine3": "MRZ Linea 3",
  "EXTRACTED_FIELDS_ObservationPage": "Pagina di osservazione",
  "EXTRACTED_FIELDS_IssuingAuthority": "Autorità emittente",
  "EXTRACTED_FIELDS_IssuingLocation": "Luogo di emissione",
  "EXTRACTED_FIELDS_MaritalStatus": "Stato civile",
  "EXTRACTED_FIELDS_Occupation": "Occupazione",
  "EXTRACTED_FIELDS_AlienNumber": "Numero Alienigena",
  "EXTRACTED_FIELDS_Employer": "Datore di lavoro",
  "EXTRACTED_FIELDS_AddressLine1": "Indirizzo Linea 1",
  "EXTRACTED_FIELDS_AddressLine2": "Indirizzo Linea 2",
  "EXTRACTED_FIELDS_AddressLine3": "Indirizzo Linea 3",
  "EXTRACTED_FIELDS_AddressLine4": "Indirizzo Linea 4",
  "EXTRACTED_FIELDS_AddressState": "Stato",
  "EXTRACTED_FIELDS_AddressDistrict": "Distretto",
  "EXTRACTED_FIELDS_AddressBuildingNumber": "Numero dell'edificio",
  "EXTRACTED_FIELDS_AddressBuildingName": "Nome dell'edificio",
  "EXTRACTED_FIELDS_AddressStreet": "Strada",
  "EXTRACTED_FIELDS_AddressCountry": "Paese",
  "EXTRACTED_FIELDS_RefAddressFull": "Indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressLine1": "Indirizzo di riferimento Linea 1",
  "EXTRACTED_FIELDS_RefAddressLine2": "Riferimento Indirizzo Linea 2",
  "EXTRACTED_FIELDS_RefAddressLine3": "Riferimento Indirizzo Linea 3",
  "EXTRACTED_FIELDS_RefAddressLine4": "Riferimento Indirizzo Linea 4",
  "EXTRACTED_FIELDS_RefAddressCity": "Indirizzo di riferimento Città",
  "EXTRACTED_FIELDS_RefAddressState": "Stato dell'indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressDistrict": "Indirizzo di riferimento Distretto",
  "EXTRACTED_FIELDS_RefAddressBuildingNumber": "Numero di edificio dell'indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressBuildingName": "Indirizzo di riferimento Nome dell'edificio",
  "EXTRACTED_FIELDS_RefAddressSubBuildingName": "Indirizzo di riferimento Nome del sottopassaggio.",
  "EXTRACTED_FIELDS_RefAddressStreet": "Indirizzo di riferimento Via",
  "EXTRACTED_FIELDS_RefAddressCountry": "Indirizzo di riferimento Paese",
  "EXTRACTED_FIELDS_RefAddressPostCode": "Indirizzo di riferimento Codice postale",
  "EXTRACTED_FIELDS_HealthNumber": "Numero di salute",
  "EXTRACTED_FIELDS_Endorsements": "Raccomandazioni",
  "EXTRACTED_FIELDS_Constraints": "Vincoli",
  "EXTRACTED_FIELDS_LicenseMarine": "Licenza marittima",
  "EXTRACTED_FIELDS_Height": "Altezza",
  "EXTRACTED_FIELDS_Weight": "Peso",
  "EXTRACTED_FIELDS_HairColor": "Colore dei capelli",
  "EXTRACTED_FIELDS_EyeColor": "Colore degli occhi",
  "EXTRACTED_FIELDS_LensData": "Vista",
  "EXTRACTED_FIELDS_SocialSecurityNumber": "Numero di previdenza sociale",
  "EXTRACTED_FIELDS_NationalInsuranceNumber": "Numero di assicurazione nazionale",
  "EXTRACTED_FIELDS_Race": "Gara",
  "EXTRACTED_FIELDS_MotherName": "Nome della madre",
  "EXTRACTED_FIELDS_FatherName": "Nome del padre",
  "EXTRACTED_FIELDS_Parents": "Genitori",
  "EXTRACTED_FIELDS_Remarks": "Osservazioni",
  "EXTRACTED_FIELDS_DistinguishingMarks": "Segni distintivi",
  "EXTRACTED_FIELDS_PeriodOfStay": "Periodo di soggiorno",
  "EXTRACTED_FIELDS_TaxNumber": "Numero di identificazione fiscale",
  "EXTRACTED_FIELDS_Donor": "Donatore",
  "EXTRACTED_FIELDS_RFIDG1": "Dati grezzi RFID Gruppo 1",
  "EXTRACTED_FIELDS_RFIDG2": "Dati grezzi RFID Gruppo 2",
  "EXTRACTED_FIELDS_RFIDG3": "Dati grezzi RFID Gruppo 3",
  "EXTRACTED_FIELDS_RFIDG15": "Dati grezzi RFID Gruppo 4",
  "EXTRACTED_FIELDS_RFIDSOD": "Dati grezzi RFID Gruppo 5",
  "EXTRACTED_FIELDS_PortraitPhoto": "Foto ritratto estratta",
  "EXTRACTED_FIELDS_Title": "Titolo",
  "EXTRACTED_FIELDS_IssueDate2": "Data di seconda emissione",
  "EXTRACTED_FIELDS_ExpiryDate2": "Seconda data di scadenza",
  "EXTRACTED_FIELDS_LicenseCategory2": "Seconda categoria di licenza",
  "EXTRACTED_FIELDS_IssueDate3": "Data di terza emissione",
  "EXTRACTED_FIELDS_ExpiryDate3": "Terza data di scadenza",
  "EXTRACTED_FIELDS_LicenseCategory3": "Terza categoria di licenza",
  "EXTRACTED_FIELDS_IssueDate4": "Quarta data di emissione",
  "EXTRACTED_FIELDS_ExpiryDate4": "Quarta data di scadenza",
  "EXTRACTED_FIELDS_MRZCode1": "Codice MRZ 1",
  "EXTRACTED_FIELDS_MRZCode2": "Codice MRZ 2",
  "EXTRACTED_FIELDS_MRZStandardType": "Tipo standard MRZ",
  "EXTRACTED_FIELDS_AddressStreetSuffix": "Suffisso stradale",
  "EXTRACTED_FIELDS_AddressStreetType": "Tipo di strada",
  "EXTRACTED_FIELDS_AddressUnitNumber": "Numero dell'unità dell'indirizzo",
  "EXTRACTED_FIELDS_LicenseNumber": "Numero di licenza",
  "EXTRACTED_FIELDS_AddressStateCode": "Codice di Stato",
  "EXTRACTED_FIELDS_AddressStreetTypeAbbreviation": "Abbreviazione di strada",
  "EXTRACTED_FIELDS_AddressUnitType": "Tipo di unità indirizzo",
  "EXTRACTED_FIELDS_AddressDeliveryPointIdentifier": "Identificatore del punto di consegna",
  "EXTRACTED_FIELDS_AgeCategory": "Categoria di età",
  "EXTRACTED_FIELDS_ChildernCount": "Numero di bambini",
  "EXTRACTED_FIELDS_EntryMode": "Modalità di ingresso",
  "EXTRACTED_FIELDS_VAFNumber": "Numero VAF",
  "EXTRACTED_FIELDS_AddressLine5": "Indirizzo Linea 5",
  "EXTRACTED_FIELDS_RFIDPortraitPhoto": "Foto del ritratto RFID",
  "EXTRACTED_FIELDS_RefAddressLine5": "Riferimento Indirizzo Linea 5",
  "EXTRACTED_FIELDS_RefAddressStateCode": "Stato dell'indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressStreetType": "Tipo di strada dell'indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation": "Tipo di abbreviazione dell'indirizzo di riferimento.",
  "EXTRACTED_FIELDS_RefAddressStreetSuffix": "Suffisso della via dell'indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressUnitNumber": "Numero dell'unità di indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressUnitType": "Unità di indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressPostcodeType": "Indirizzo di riferimento CAP Tipo",
  "EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier": "Identificatore del punto di consegna dell'indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressPOBoxNumber": "Indirizzo di riferimento Numero casella postale",
  "EXTRACTED_FIELDS_RefAddressDependentLocality": "Località dipendente dall'indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressDoubleDependentLocality": "Indirizzo di riferimento Doppia Località Dipendente",
  "EXTRACTED_FIELDS_RefAddressThoroughfare": "Indirizzo di riferimento Strada",
  "EXTRACTED_FIELDS_RefAddressThoroughfareDesc": "Descrizione dell'indirizzo di riferimento.",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfare": "Thoroughfare Dipendente dall'Indirizzo di Riferimento",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc": "Descrizione della strada dipendente dall'indirizzo di riferimento",
  "EXTRACTED_FIELDS_RefAddressSubBuildingNumber": "Numero di edificio sottostante all'indirizzo di riferimento",
  "EXTRACTED_FIELDS_AddressSubBuildingNumber": "Numero dell'edificio",
  "EXTRACTED_FIELDS_AddressSubBuildingName": "Nome dell'edificio principale",
  "EXTRACTED_FIELDS_AddressPostCodeType": "Tipo di codice postale",
  "EXTRACTED_FIELDS_IssuingAuthorityType": "Tipo di Autorità Emittente",
  "EXTRACTED_FIELDS_Signature": "Firma",
  "EXTRACTED_FIELDS_Hologram": "Ologramma",
  "EXTRACTED_FIELDS_CardNumber": "Numero di carta",
  "EXTRACTED_FIELDS_MiddleNameInitial": "Iniziale del secondo nome",
  "EXTRACTED_FIELDS_PermitNumber": "Numero di autorizzazione",
  "EXTRACTED_FIELDS_ReferenceNumber": "Numero di riferimento",
  "EXTRACTED_FIELDS_CustomerNumber": "Numero cliente",
  "EXTRACTED_FIELDS_BOSNumber": "Numero BOS",
  "EXTRACTED_FIELDS_StudentID": "Numero di identificazione dello studente",
  "EXTRACTED_FIELDS_MembershipNumber": "Numero di iscrizione",
  "EXTRACTED_FIELDS_LicenseType": "Tipo di licenza",
  "EXTRACTED_FIELDS_LicenseType2": "Tipo di licenza 2",
  "EXTRACTED_FIELDS_LicenseType3": "Tipo di licenza 3",
  "EXTRACTED_FIELDS_LicenseType4": "Tipo di licenza 4",
  "EXTRACTED_FIELDS_DocumentTypeCode": "Codice Tipo Documento",
  "EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit": "Cifra di controllo MRZ",
  "EXTRACTED_FIELDS_MRZBirthDateCheckDigit": "Cifra di controllo della data di nascita MRZ",
  "EXTRACTED_FIELDS_MRZExpiryDateCheckDigit": "Cifra di controllo della data di scadenza MRZ",
  "EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit": "Cifra di controllo del numero personale MRZ",
  "EXTRACTED_FIELDS_MRZCompositeCheckDigit": "Cifra di controllo composita MRZ",
  "EXTRACTED_FIELDS_SecondaryPortraitPhoto": "Foto del ritratto secondario",
  "EXTRACTED_FIELDS_Fingerprint": "Impronta digitale",
  "EXTRACTED_FIELDS_VersionNumber": "Numero di versione",
  "EXTRACTED_FIELDS_Conditions": "Condizioni",
  "EXTRACTED_FIELDS_NickName": "Soprannome",
  "EXTRACTED_FIELDS_AddressApartmentNumber": "Numero dell'appartamento",
  "EXTRACTED_FIELDS_AddressFloorNumber": "Numero del piano",
  "EXTRACTED_FIELDS_FirstNameLocal": "Primo Nome Locale",
  "EXTRACTED_FIELDS_LastNameLocal": "Ultimo Nome Locale",
  "EXTRACTED_FIELDS_FullNameLocal": "Nome completo Locale",
  "EXTRACTED_FIELDS_BirthPlaceLocal": "Luogo di nascita locale",
  "EXTRACTED_FIELDS_IssuingAuthorityLocal": "Autorità di emissione locale",
  "EXTRACTED_FIELDS_MotherNameLocal": "Madre Nome Locale",
  "EXTRACTED_FIELDS_FatherNameLocal": "Padre Nome Locale",
  "EXTRACTED_FIELDS_AddressFullLocal": "Indirizzo Completo Locale",
  "EXTRACTED_FIELDS_MiddleNameLocal": "Nome di mezzo Locale",
  "EXTRACTED_FIELDS_AddressLine1Local": "Indirizzo Linea1 Locale",
  "EXTRACTED_FIELDS_AddressLine2Local": "Indirizzo Linea2 Locale",
  "EXTRACTED_FIELDS_AddressLine3Local": "Indirizzo Linea3 Locale",
  "EXTRACTED_FIELDS_IndRefNumber1": "Numero di riferimento individuale 1",
  "EXTRACTED_FIELDS_IndRefNumber2": "Numero di riferimento individuale 2",
  "EXTRACTED_FIELDS_IndRefNumber3": "Numero di riferimento individuale 3",
  "EXTRACTED_FIELDS_IndRefNumber4": "Numero di riferimento individuale 4",
  "EXTRACTED_FIELDS_IndRefNumber5": "Numero di riferimento individuale 5",
  "EXTRACTED_FIELDS_Name1": "Nome 1",
  "EXTRACTED_FIELDS_Name2": "Nome 2",
  "EXTRACTED_FIELDS_Name3": "Nome 3",
  "EXTRACTED_FIELDS_Name4": "Nome 4",
  "EXTRACTED_FIELDS_Name5": "Nome 5",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_1": "Nome del destinatario 1",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_2": "Nome del destinatario 2",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_3": "Nome del destinatario 3",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_4": "Nome del destinatario 4",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL": "Indirizzo del destinatario Completo",
  "EXTRACTED_FIELDS_IBAN": "Numero di conto IBAN",
  "EXTRACTED_FIELDS_ACCOUNT_NUM": "Numero di conto",
  "EXTRACTED_FIELDS_ISSUER": "Emittente",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY": "Indirizzo del destinatario Città",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE": "Indirizzo del destinatario Codice postale",
  "EXTRACTED_FIELDS_DAY": "Giorno",
  "EXTRACTED_FIELDS_MONTH": "Mese",
  "EXTRACTED_FIELDS_YEAR": "Anno",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_1": "Valore opzionale 1",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_2": "Valore opzionale 2",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_3": "Valore opzionale 3",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_4": "Valore opzionale 4",
  "EXTRACTED_FIELDS_ISSUING_STATE_NAME": "Nome dello Stato emittente",
  "EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID": "Id del tipo di documento sul lato anteriore",
  "EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID": "Id del tipo di documento sul retro",
  "HASNOCAMERA_TITLE": "Oops, non siamo riusciti a riconoscere una fotocamera sul tuo dispositivo!",
  "HASNOCAMERA_DESCRIPTION": "Sembra che il dispositivo in uso non disponga di una fotocamera; si prega di riprovare con un altro dispositivo dotato di fotocamera funzionante in modo da poter eseguire tutti i passaggi richiesti.",
  "EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT": "Tipo Covid Id",
  "USER_INPUT_FIRST_NAME": "Nome",
  "USER_INPUT_MIDDLE_NAME": "Secondo nome",
  "USER_INPUT_LAST_NAME": "Cognome",
  "USER_INPUT_DOB": "Data di nascita",
  "USER_INPUT_HOUSE_NAME_NUMBER": "Nome/numero civico*",
  "USER_INPUT_STREET_NAME": "Nome della strada*",
  "USER_INPUT_TOWN": "Città*",
  "USER_INPUT_POSTAL_CODE": "Codice postale*",
  "USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE": "es. Casa/35",
  "USER_INPUT_STREET_NAME_EXAMPLE": "es. Via Test",
  "USER_INPUT_TOWN_EXAMPLE": "es. Somewhere",
  "USER_INPUT_POSTAL_CODE_EXAMPLE": "es. CH496 (senza spazi)",
  "SYSTEM_NOT_ABLE": "Il sistema non è riuscito a scansionare il documento",
  "TRY_AGAIN": "Riprova",
  "HINTS_DISABLED_HEADER": "Gli indizi sono disattivati in modalità manuale",
  "HINTS_DISABLED_DESCRIPTION": "Se vuoi attivare gli indizi per scattare una foto, passa alla modalità ACQUISIZIONE AUTOMATICA",
  "YOU_HAVE": "Hai",
  "PICTURE_VERIFYING": "Verifica in corso...",
  "HOW_TO_TAKE_PHOTO_CORRECTLY": "Come scattare una foto correttamente"
}